import category from ".sourceflow/employer_page_filters.json";
import useSourceFlowCollection from "@/hooks/useSourceFlowCollection";

export const useEmployerPageFilters = () => {
  const collection = useSourceFlowCollection(category);

  return collection;
};

export default useEmployerPageFilters;
